import { ExchangeMultiSelect } from './ExchangeMultiSelect'
import type { ParserFilters } from './model'
import { Spinner } from '@/components/common/Spinner'
import { NumberField } from '@/components/common/NumberField'
import { InfoHint } from '@/components/common/InfoHint'
import { RefreshIcon, SearchIcon } from '@/components/common/icons'

interface FiltersBarProps {
  filters: ParserFilters
  exchanges: string[]
  onChange: (patch: Partial<ParserFilters>) => void
  onRefresh: () => void
  refreshing: boolean
}

export function FiltersBar({ filters, exchanges, onChange, onRefresh, refreshing }: FiltersBarProps) {
  return (
    <div className="card filters">
      <div className="field filters__search">
        <div className="field__labelrow">
          <label className="field__label" htmlFor="f-search">
            Поиск монеты
          </label>
          <InfoHint text="Поиск по тикеру монеты среди показанных строк (сейчас — топ-100 по размаху фандинга; монета вне топа не найдётся)." />
        </div>
        <div className="input">
          <SearchIcon size={16} className="input__icon" />
          <input
            id="f-search"
            type="text"
            placeholder="BTC, ETH, SOL…"
            value={filters.search}
            onChange={(e) => onChange({ search: e.target.value })}
            autoComplete="off"
          />
        </div>
      </div>

      <div className="field filters__num">
        <div className="field__labelrow">
          <label className="field__label" htmlFor="f-funding">
            Мин. фандинг
          </label>
          <InfoHint text="Показывать только пары, у которых размах ставок фандинга между биржами не меньше указанного процента." />
        </div>
        <NumberField
          id="f-funding"
          value={filters.minFundingPct}
          onChange={(minFundingPct) => onChange({ minFundingPct })}
          placeholder="0"
          suffix="%"
        />
      </div>

      <div className="field filters__num">
        <div className="field__labelrow">
          <label className="field__label" htmlFor="f-volume">
            Мин. объём
          </label>
          <InfoHint text="Скрыть монеты, у которых суточный оборот (USDT) на всех выбранных биржах ниже порога. Котировки без объёма не отсекаются (пермиссивно)." />
        </div>
        <NumberField
          id="f-volume"
          value={filters.minVolumeUsd}
          onChange={(minVolumeUsd) => onChange({ minVolumeUsd })}
          placeholder="20000"
          inputMode="numeric"
          suffix="$"
        />
      </div>

      <div className="field">
        <div className="field__labelrow">
          <span className="field__label">Биржи</span>
          <InfoHint text="Какие биржи учитывать. Колонки таблицы и размах фандинга считаются только по выбранным биржам; нужно минимум 2, чтобы получилась пара." />
        </div>
        <ExchangeMultiSelect
          options={exchanges}
          selected={filters.selectedExchanges}
          onChange={(selectedExchanges) => onChange({ selectedExchanges })}
        />
      </div>

      <div className="filters__spacer" />

      <div className="filters__actions">
        <button
          type="button"
          className="btn btn--primary"
          onClick={onRefresh}
          disabled={refreshing}
        >
          {refreshing ? <Spinner size={15} className="btn__spin" /> : <RefreshIcon size={16} />}
          {refreshing ? 'Обновление…' : 'Обновить'}
        </button>
      </div>
    </div>
  )
}
